/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useRef } from "react";
import { Button, Col, Row } from "antd";
import { ArrowRightOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { State } from "../../../../model/application/state";
import { UserAuthentication } from "../../../../service/action/merchant";
import { URLSearch } from "../../../../shared/component/urlSearch";
import "./style.css";
import nn from "../../../../images/kk.svg";
import Logo from "../../../../images/logo.svg";
import { Link } from "react-router-dom";
import { GiHamburgerMenu } from "react-icons/gi";
import { AiOutlineClose } from "react-icons/ai";

export const ContentSection: React.FC = () => {
  const { utilityState, merchantLandingPage }: any = useSelector(
    (state) => state
  );
  const state: State.Config = utilityState;
  const landingPageState: State.UserValidation = merchantLandingPage;

  const merchantPortalDomain = localStorage.getItem("$$$$") ?? ''
  const loginPopupRef = useRef<Window | null>(null);

  const ShowMobileMenu = useCallback(() => {
    dispatch({
      type: UserAuthentication.SET_USER_AUTHENTICATION,
      payload: {
        ...landingPageState,
        showMobileMenu: true,
      },
    });
  }, [landingPageState]);

  const dispatch = useDispatch();
  
  const handleGetStartedButtonClick = useCallback(() => {
    if (!sessionStorage.getItem("***")) {
      window.location.href = `${merchantPortalDomain}/merchant-registration`
    } else {
      dispatch({
        type: UserAuthentication.GET_USER_AUTHENTICATION,
        payload: {
          ...landingPageState,
          isProcessing: true,
          ssoDomain: state.data?.ssoDomain,
          token: URLSearch.getParameterByName("token").replace(/\s/g, ""),
          showMobileMenu: false,
        },
      });
    }
  }, [state]);

  const handleLoginButtonClick = useCallback(() => {
    // Define window dimensions
    const width = 800
    const height = 800

    // Calculate center position
    const left = (window.screen.width - width) / 2
    const top = (window.screen.height - height) / 2

    // Window features with calculated position
    const windowFeatures = [
      `width=${width}`,
      `height=${height}`,
      `left=${left}`,
      `top=${top}`,
      'resizable=yes',
      'scrollbars=yes',
      'toolbar=no',
      'menubar=no',
      'location=no',
      'status=no'
    ].join(',')

    loginPopupRef.current = window.open(
      `${merchantPortalDomain}/login?rdt=true`,
      'centeredPopup',
      windowFeatures
    )
  }, [state]);

  // Bridges the login popup back to this window: the merchant portal login
  // page runs on a different origin (merchantPortalDomain), so a top-level
  // redirect on the popup can't hand the token to this window on its own.
  // The popup must postMessage({ source: "xpress-merchant-portal", token })
  // back to window.opener once login succeeds.
  useEffect(() => {
    if (!merchantPortalDomain) return;

    const merchantPortalOrigin = new URL(merchantPortalDomain).origin;

    const handleAuthMessage = (event: MessageEvent) => {
      if (event.origin !== merchantPortalOrigin) return;
      if (event.data?.source !== "xpress-merchant-portal" || !event.data?.token) return;

      dispatch({
        type: UserAuthentication.GET_USER_AUTHENTICATION,
        payload: {
          ...landingPageState,
          isProcessing: true,
          ssoDomain: state.data?.ssoDomain,
          token: String(event.data.token).replace(/\s/g, ""),
          showMobileMenu: false,
        },
      });

      loginPopupRef.current?.close();
      loginPopupRef.current = null;
    };

    window.addEventListener("message", handleAuthMessage);
    return () => window.removeEventListener("message", handleAuthMessage);
  }, [merchantPortalDomain, landingPageState, state, dispatch]);


  const CloseMobileMenu = useCallback(() => {
    dispatch({
      type: UserAuthentication.SET_USER_AUTHENTICATION,
      payload: {
        ...landingPageState,
        showMobileMenu: false,
      },
    });
  }, [state]);

  return (
    <div className="bg-red-800 w-full h section grid grid-rows-[3.5rem_1fr]">
      <header className="flex w-full  header-section bg-primary-white justify-between lg:items-center items-center py-2 px-10 lg:px-3">
        <img
          src={Logo}
          onClick={() => <Link to={"/"} />}
          alt="logo-imag"
          className="w-[12rem] md:w-[8rem] h-[12rem] md:ml-[-20px]"
        />
        <button
          className="hidden text-primary-black lg:block text-3xl"
          onClick={ShowMobileMenu}
        >
          <GiHamburgerMenu className="text-primary-black" />
        </button>
        <ul
          className={` text-primary-black lg:shadow-md  gap-5 ${
            landingPageState.showMobileMenu ? "grid" : "lg:hidden"
          } font-extralight lg:font-normal lg:w-[15rem] lg:z-10 lg:bg-primary-white lg:h-screen lg:justify-center lg:place-content-start lg:px-5 lg:py-[10rem] lg:text-md lg:absolute lg:right-0 lg:top-0`}
        >
          <div
            className="text-xl hidden lg:block absolute top-10 right-10"
            onClick={CloseMobileMenu}
          >
            <AiOutlineClose />
          </div>
          <a
            href={"/"}
            className="lg:flex py-2 px-5 font-semibold text-primary-black"
          >
            Home
          </a>
          <a
            href={state.data?.xpressWebsiteLink?.About}
            target="_blank"
            className="lg:flex py-2 px-5 font-semibold text-primary-black"
          >
            About
          </a>
          <a
            href={state.data?.xpressWebsiteLink?.ContactUs}
            className="lg:flex py-2 px-5 font-semibold text-primary-black"
            target="_blank"
          >
            Contact Us
          </a>
          <a
            href="https://docsbillerservices.xpresspayments.com/"
            className="lg:flex py-2 px-5 font-semibold text-primary-black"
            target="_blank"
          >
            Docs
          </a>

          <Button
            type="primary"
            onClick={handleLoginButtonClick}
          >
            Login
          </Button>
        </ul>
      </header>

      <Row className="flex w-full h-auto items-center justify-center bg-praimry-green px-5 md:px-2">
        <Col md={12} xs={24}>
          <section
            className="md:w-full grid my-auto justify-center"
            data-aos="zoom-in-down"
          >
            <span
              className="text-black text-[3.5rem] md:text-center lg:text-[1.5rem] h1 w-full md:leading-normal leading-tight "
              style={{ color: "#2B872B", marginBottom: 25 }}
            >
              BILLER SERVICE
            </span>
            <div className="text-black text-[3.5rem] md:text-center md:text-[2rem] h1 w-full md:leading-normal leading-tight ">
              <h2 className="text-[2.5rem] lg:text-xl">
                More opportunities for Businesses
              </h2>
            </div>
            <div className="text-[1.3rem] max-w-[35rem] mt-3 xl:text-[1rem] md:text-[0.8rem] leading-loose text-justify md:mx-2">
              This platform serves as an opportunity for businesses to engage in
              large-scale reselling of VAS products, allowing them to earn
              commissions. With its user-friendly and easily integrable APIs,
              the platform ensures seamless integration, while also offering a
              robust reporting module for comprehensive data analysis.
            </div>
            <Button
              type="primary"
              className="mt-10 w-fit md:mx-auto rounded-full"
              size="large"
              onClick={() => {
                handleGetStartedButtonClick();
              }}
            >
              <p
                style={{ color: "white", fontSize: 15 }}
                className="flex gap-3 items-center"
              >
                Get started as a merchant{" "}
                <ArrowRightOutlined className="text-primary-white" rev={undefined} />
              </p>
            </Button>
          </section>
        </Col>
        <Col md={12}>
          <section
            className=" grid gap-y-2.5 place-items-center"
            data-aos="zoom-in-up"
          >
            <img src={nn} alt="b1" className="bg-logo w-[90%]" />
          </section>
        </Col>
      </Row>
       <footer className="text-center flex items-center justify-center w-full mx-auto py-5">
      <img src="https://sso.xpresspayments.com:25018/static/media/cbn.561775efab2fb75c3148efd434532c5d.svg" alt="" className="w-[40%]" />
    </footer>
    </div>
  );
};
